import "./index.scss";
import { Fade, Bounce, Zoom } from "react-awesome-reveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import imgAdmin from "../../../assets/images/imgAdmin.jpg";
import imgTeacher from "../../../assets/images/imgTeacher.jpg";
import imgParent from "../../../assets/images/imgParent.jpg";

const SectionWho = () => {
  return (
    <div className="section-who">
      <div className="header" align="center">
        <div className="header-content">
          <Bounce cascade>
            <h1 className="title-text">Who MygradeCard is for</h1>
          </Bounce>
          <Fade delay={100} cascade>
            <p>
              MyGradeCard System provides a thorough management features that
              helps your school with delivering of both academics and
              administrative services effectively and efficiently, While helping
              your organisation to increase efficiency by modernizing operations
              and reducing cost.
            </p>
          </Fade>
        </div>
      </div>

      <div className="w3-container">
        <div className="w3-row">
          <div className="w3-half">
            <div className="imgDiv">
              <Fade direction="left" delay={100} cascade>
                <img src={imgAdmin} className="img" alt="Admin" />
              </Fade>
            </div>
          </div>
          <div className="w3-half">
            <div className="textDiv">
              <div className="textDivContent">
                <Zoom cascade>
                  <h1>School Administrator</h1>
                </Zoom>
                <Fade delay={200} cascade>
                  <p>
                    MyGradeCard provides a comprehensive management system that
                    helps you efficiently streamline operations and reduce
                    resources and costs within your school organization.
                  </p>
                </Fade>
                <Fade direction="down" delay={100} cascade>
                  <ul>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Modernize operations
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Eliminate financial leakages (100%)
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Stress free report.
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Efficient service delivery
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Monitor the activities of your school
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Save cost and boost productivity
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />{" "}
                      Easy Result compilation
                    </li>
                  </ul>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w3-container">
        <div className="w3-row row-container">
          <div className="w3-half">
            <div align="center" className="textDiv">
              <div className="textDivContent">
                <Zoom cascade>
                  <h1>Teacher</h1>
                </Zoom>
                <Fade delay={200} cascade>
                  <p>
                    MyGradeCard reduces workload of teachers, boost their
                    productivity and efficiency, improving their capabilities
                    and capacity, making teaching easier.
                  </p>
                </Fade>
                <Fade direction="down" delay={100} cascade>
                  <ul>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Compilation of results with ease and accuracy (100%) .
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Boost productivity.
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Reduce workload and paper work
                    </li>
                  </ul>
                </Fade>
              </div>
            </div>
          </div>
          <div className="w3-half ">
            <div className="imgDiv">
              <Fade direction="right" delay={100} cascade>
                <img src={imgTeacher} className="img" alt="Teacher" />
              </Fade>
            </div>
          </div>
        </div>
      </div>

      <div className="w3-container">
        <div className="w3-row">
          <div className="w3-half">
            <div className="imgDiv">
              <Fade direction="left" delay={100} cascade>
                <img src={imgParent} className="img" alt="" />
              </Fade>
            </div>
          </div>
          <div className="w3-half">
            <div className="textDiv">
              <div className="textDivContent">
                <Zoom cascade>
                  <h1>Parent</h1>
                </Zoom>
                <Fade delay={200} cascade>
                  <p>
                    MyGradeCard helps parents to engage in school activities of
                    their wards, make payments of school fees from the comfort
                    of your homes.
                  </p>
                </Fade>
                <Fade direction="down" delay={100} cascade>
                  <ul>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Know your ward’s performance on the go.
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Easy and reliable way to pay school fees.
                    </li>
                    <li>
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="icon"
                        size="lg"
                      />
                      Be on track with your child/wards school activities.
                    </li>
                  </ul>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWho;
